/**
 * Global registry for resource API path mappings
 * Used by data provider to determine correct API paths for each resource
 */

export interface ResourceMetadata {
  resourceName: string;
  apiPath: string;
  dataModelKey?: string;
  schemaKey?: string; // Key for fetching schema definition (includes editorSchema)
  schemaId?: string; // ID for fetching schema definition
}

class ResourceRegistry {
  private registry = new Map<string, ResourceMetadata>();

  register(resourceName: string, metadata: ResourceMetadata) {
    this.registry.set(resourceName.toLowerCase(), metadata);
  }

  getApiPath(resourceName: string): string | undefined {
    return this.registry.get(resourceName.toLowerCase())?.apiPath;
  }

  getDataModelKey(resourceName: string): string | undefined {
    return this.registry.get(resourceName.toLowerCase())?.dataModelKey;
  }

  getSchemaKey(resourceName: string): string | undefined {
    return this.registry.get(resourceName.toLowerCase())?.schemaKey;
  }

  getSchemaId(resourceName: string): string | undefined {
    return this.registry.get(resourceName.toLowerCase())?.schemaId;
  }

  getMetadata(resourceName: string): ResourceMetadata | undefined {
    return this.registry.get(resourceName.toLowerCase());
  }

  clear() {
    this.registry.clear();
  }

  getAll(): ResourceMetadata[] {
    return Array.from(this.registry.values());
  }
}

// Singleton instance
export const resourceRegistry = new ResourceRegistry();

